// strategyStore.ts
import { atom } from "nanostores"
import { type AnalyzerStrategy } from "@/types/analysisTypes"

export const currentStrategy = atom<AnalyzerStrategy | null>("Fix & Flip")

export function setStrategy(strategy: AnalyzerStrategy) {
  // const current = currentStrategy.get()
  currentStrategy.set(strategy)
}
